export interface ChannelAPIStatus {
  isFetching: boolean
  hasData: boolean
  hasError: boolean
  errorResponse: {
    code?: number,
    message?: string
  }
}
export interface FeaturesObject {
  name: string
  enabled: boolean
  value?: string
}

export interface featuredCommunicationsObject {
  id: number,
  title: string,
  description: string,
  start: string,
  duration: number,
  thumbnailLink: {
    href: string,
    rel: string,
    type: string,
    title: string
  }
}

export interface ChannelServiceResponse {
  id?: number
  title: string
  description: string
  organisation: string
  keywords: string
  keywordsList: string[]
  strapline: string
  url: string
  promoteable: boolean
  searchVisibility: string
  rating?: number
  currentType: string
  createdType: string
  created?: string
  lastUpdated?: string
  statistics?: {
    viewedSeconds: number,
    upcomingCommunications: number,
    liveCommunications: number,
    recordedCommunications: number,
    subscribers: number
  }
  user?: {
    id: number,
    email?: string
  }
  survey?: {
    id: number,
    isActive: boolean
  }
  features: FeaturesObject[]
  communities: any[]
  featuredCommunications?: featuredCommunicationsObject[]
}

interface ChannelManagers {
  inProgress: boolean
  data: any
  error: any,
  revokeInProgress: boolean
  addingInProgress: boolean
  addingStatus: string
  addingErrors: any
  added: number
  page: number
  total: number
  errorMessage?: string
}

interface ChannelsList {
  owner: {
    email: string,
  },
  title: string,
  totalCommunications: number,
  id: number,
}

interface UpdateChannelReducerState {
  inProgress: boolean
  error: string
  errorCode: string
  status: string
}

interface ChannelListInterface {
  inProgress: boolean
  error: any
  data: any
  total: number
}

interface CreateChannelInterface {
  inProgress: boolean
  status: string
  error: any
  createdId: string
}

export interface ChannelReducerDefaultState {
  status: ChannelAPIStatus
  data: ChannelServiceResponse
  managers: ChannelManagers
  update: UpdateChannelReducerState
  list: ChannelListInterface
  create: CreateChannelInterface
  logoUpload: {
    inProgress: boolean
  }
}

export const defaultState: ChannelReducerDefaultState = {
  status: {
    errorResponse: {},
    hasData: false,
    hasError: false,
    isFetching: false
  },
  data: {
    title: '',
    description: '',
    organisation: '',
    keywords: '',
    keywordsList: [],
    strapline: '',
    url: '',
    promoteable: false,
    searchVisibility: '',
    currentType: '',
    createdType: '',
    features: [],
    communities: []
  },
  managers: {
    inProgress: false,
    data: [],
    error: null,
    revokeInProgress: false,
    addingInProgress: false,
    addingStatus: '',
    addingErrors: null,
    added: 0,
    page: 1,
    total: 0,
    errorMessage: ''
  },
  update: {
    inProgress: false,
    error: '',
    errorCode: '',
    status: 'not-updated'
  },
  list: {
    inProgress: false,
    error: null,
    data: [],
    total: 0
  },
  create: {
    inProgress: false,
    error: null,
    status: '',
    createdId: ''
  },
  logoUpload: {
    inProgress: false
  }
}

export default defaultState
